import { render, staticRenderFns } from "./refund-list.vue?vue&type=template&id=874ef8f4&scoped=true&"
import script from "./refund-list.vue?vue&type=script&lang=js&"
export * from "./refund-list.vue?vue&type=script&lang=js&"
import style0 from "./refund-list.vue?vue&type=style&index=0&id=874ef8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874ef8f4",
  null
  
)

export default component.exports